import React, { useState } from 'react'
import { View } from 'styles/reactnative'

import { useExchangeList } from '../../../hooks/trade/exchangeList'
import { Button, Input, Popover, Select, Space } from 'antd'
import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import TableAPI from '../../../components/TableAPI'
import CRenderEmpty from '../../../components/CRenderEmpty'
import { PositionClosedTableColumn } from './PositionClosedTableColumn'
import { useUserList } from '../../../hooks/user/userlist'

const PositionClosed = ({ title, type }: any) => {
	const params = new URLSearchParams(window.location.search)
	const idquery = params.get('userid')

	const [user_id, setUser_id] = useState<any>(idquery || '')
	const [status, setStatus] = useState<any>('*')
	const [ep_id, setEp_id] = useState<any>('*')
	const { data: EPS } = useExchangeList()
	const today = new Date().toISOString().slice(0, 10)
	const activeEPS = EPS?.filter((item: any) => item.openstatus !== 4 && item.startdate <= today && item.enddate > today)

	const { usertype1 } = useUserList()

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<Select
					value={ep_id}
					onChange={e => {
						setEp_id(e)
					}}
					filterOption={true}
					options={[
						{ value: '*', label: '전체종목' },
						...activeEPS?.map((item: any) => {
							return {
								value: item.id,
								label: (item.groupname || item.name) + ' (' + item?.pairs + ')',
							}
						}),
					]}
					style={{ marginRight: 10, minWidth: 200 }}
				/>
				<Space.Compact direction="horizontal">
						<Popover
							placement="bottom"
							trigger={'click'}
							content={
								<Space style={{ alignItems: 'center' }}>
									<Select
										style={{ width: '100%', minWidth: 200 }}
										defaultValue={''}
										onChange={e => {
											setUser_id(e)
										}}
										options={[
											{ value: '', label: '전체' },
											...(usertype1 || []),
										]}
									/>
								</Space>
							}>
							<Input
								placeholder="회원코드"
								value={user_id}
								onChange={e => {
									setUser_id(e.target.value)
								}}
							/>
						</Popover>
					<Button
						onClick={() => {
							setUser_id('')
						}}
						style={{ paddingTop: 0 }}
						size="small">
						{user_id ? <CloseOutlined /> : <SearchOutlined />}
					</Button>
				</Space.Compact>
			</View>

			<TableAPI
				title={title}
				columns={PositionClosedTableColumn}
				usermodal={true}
				height={'default'}
				width={1400}
				apikey={
					'/admin/history/closedpnl?ep_id=' +
					ep_id +
					'&user_id=' +
					(user_id || '*') +
					'&status=' +
					status
				}
			/>

		</View>
	)
}

export default React.memo(PositionClosed)
